import $ from "jquery";
globalThis.jQuery = $;


jQuery("a").each(function(){
    if ( jQuery(this).children('img').length > 0 ) {
    jQuery(this).addClass("plain");
    }
});